<template>
  <div class="file-pdf" :class="fileClass">
    <div
      :src="fileSrc"
      ref="file"
      :class="{ pointer: openLink }"
      @click="viewOriginal"
    >{{ fileName }}</div>
  </div>
</template>

<script>
export default {
  props: {
    fileSrc: String,
    fileClass: {
      type: String,
      default: ""
    },
    fileName: String,
    openLink: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    viewOriginal() {
      if (this.openLink) {
        window.open(this.fileSrc);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.file-pdf {
  width: 155px;
  height: 26px;
  border-radius: 15px;
  background-color: #e0e0e0;
  float: left;
  position: relative;
  margin: 10px 10px 10px 10px;

  div {
    margin-left: 12px;
    width: 135px;
    font-size: 16px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/helper/FilePDF.vue